import { ReactNode } from 'react'
import { useBugsnagInit } from 'hooks/analytics/bugsnag/useBugsnagInit'
import type { Client } from '@bugsnag/browser'

interface BugsnagProviderProps {
  client: Client | undefined
  children: ReactNode | ReactNode[] | null
}

export const Bugsnag = ({ client, children }: BugsnagProviderProps) => {
  useBugsnagInit(client)
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
